export const UserInfo = (state) => state.user;
